export const FAQ_SAFETY_SECURE = {
  title: "AN TOÀN VÀ BẢO MẬT",
  subItems: [
    {
      id: 'nfc-authentication',
      title: "Xác thực NFC",
      contentItems: [
        {
          id: 'cau-1',
          title: "Tại sao phải xác thực CCCD gắn chip? Chứng từ khác được không?",
          content: (
            <div>
              <p className="text-gray-700">Theo Quyết định 2345/QĐ-NHNN về việc triển khai các giải pháp an toàn, bảo mật trong thanh toán trực tuyến và thanh toán thẻ ngân hàng, việc tạo tài khoản, đăng nhập trên thiết bị khác, hoặc thực hiện các giao dịch vượt hạn mức quy định trên nền tảng Ví điện tử (như GooPay) cần phải xác thực bằng phương pháp sinh trắc học (ở GooPay là xác thực khuôn mặt). Thông tin xác thực này phải được lưu trữ trong cơ sở dữ liệu sinh trắc học của khách hàng và so khớp với dữ liệu sinh trắc học thu thập từ quét NFC thẻ CCCD gắn chip do Cơ quan Công an cấp.</p>
              <p className="text-gray-700 mt-2">Theo đó, việc xác thực bằng cách chụp ảnh CMND/CCCD/Hộ chiếu trước đây sẽ không còn được chấp nhận từ khi Quyết định 2345 có hiệu lực từ 01/07/2024. Để đảm bảo tài khoản của bạn được xác thực chính chủ và tuân thủ quy định pháp luật, bạn cần cập nhật xác thực bằng cách quét NFC thẻ CCCD gắn chip càng sớm càng tốt.</p>
            </div>
          )
        },
        {
          id: 'cau-2',
          title: "Công nghệ NFC là gì?",
          content: (
            <div>
              <p className="text-gray-700">NFC là công nghệ kết nối không dây tầm ngắn trong khoảng cách 4 cm. Công nghệ này sử dụng cảm ứng từ trường để thực hiện kết nối giữa các thiết bị (smartphone, tablet,...) với CCCD gắn chip khi có sự tiếp xúc trực tiếp (chạm) để chuyển đổi dữ liệu.</p>
              <p className="text-gray-700 mt-2">GooPay áp dụng công nghệ quét NFC để đọc dữ liệu từ CCCD gắn chip của bạn và tiến hành xác thực thông tin với Bộ Công an, nhằm đảm bảo tài khoản của bạn là chính chủ và tuân thủ theo quy định pháp luật.</p>
            </div>
          )
        },
        {
          id: 'cau-3',
          title: "Thông tin từ việc quét NFC không đúng với thông tin của tôi?",
          content: (
            <div>
              <p className="text-gray-700">Thông tin đọc ra từ thẻ căn cước công dân của bạn là thông tin mà Cơ quan Công An địa phương thu thập và lưu trữ trong bộ dữ liệu dân cư quốc gia. Thông tin này bao gồm: số căn cước công dân, họ và tên, họ và tên khác, ngày, tháng, năm sinh, giới tính, quốc tịch, dân tộc, tôn giáo, ...</p>
              <p className="text-gray-700 mt-2">Trong một số trường hợp, thông tin đọc ra từ thẻ CCCD có thể không trùng khớp hoàn toàn với thông tin được in trên thẻ, do vấn đề về độ dài ký tự của thẻ vật lý không đủ không gian để nêu rõ.</p>
              <p className="text-gray-700 mt-2">Trong trường hợp thông tin đọc ra từ thẻ CCCD gắn chip khác hoàn toàn với thông tin cá nhân của bạn, bạn vui lòng đến cơ quan Công an ở địa phương để khai báo và xét duyệt cấp lại nếu cần.</p>
            </div>
          )
        },
        {
          id: 'cau-4',
          title: "Bao lâu thì xác thực NFC của tôi sẽ được duyệt?",
          content: (
            <div>
              <p className="text-gray-700">Thông thường, quá trình xác thực NFC của bạn sẽ được xét duyệt và kết quả sẽ được trả ngay khi thông tin đọc ra từ NFC được xác nhận trùng khớp với thông tin cá nhân của bạn.</p>
              <p className="text-gray-700 mt-2">Tuy nhiên, trong trường hợp bạn có hoạt động điều chỉnh/thay đổi thông tin hoặc GooPay cần thêm thời gian để xác thực thông tin của bạn, bạn sẽ nhận được thông báo từ GooPay trên màn hình kết quả xác thực NFC. Thông thường, quá trình này sẽ không mất quá 24 giờ.</p>
            </div>
          )
        },
        {
          id: 'cau-5',
          title: "Nếu không xác thực NFC thẻ CCCD gắn chip thì tôi sẽ gặp vấn đề gì ở GooPay?",
          content: (
            <div>
              <p className="text-gray-700">Trong trường hợp bạn không xác thực NFC thẻ CCCD gắn chip, sau ngày 01/07/2024, bạn sẽ bị hạn chế một số loại giao dịch tùy theo hạn mức, theo Quyết định 2345/QĐ-NHNN. Điều này sẽ ảnh hưởng đến trải nghiệm sử dụng GooPay của bạn và GooPay không thể đảm bảo an toàn cho tài khoản của bạn.</p>
            </div>
          )
        },
        {
          id: 'cau-6',
          title: "Điện thoại của tôi có quét được NFC không? Làm sao để bật tính năng NFC trên điện thoại?",
          content: (
            <div>
              <p className="text-gray-700">Đối với thiết bị sử dụng hệ điều hành iOS, đầu đọc NFC được hỗ trợ từ dòng điện thoại iPhone 6s trở lên. Thông thường, tính năng NFC luôn được kích hoạt trên các dòng điện thoại iPhone.</p>
              <p className="text-gray-700 mt-2">Đối với thiết bị Android, bạn có thể kiểm tra xem thiết bị của bạn có hỗ trợ NFC hay không bằng cách tìm kiếm trên internet với cú pháp: "[tên thiết bị] có hỗ trợ NFC không?" Nếu thiết bị của bạn có hỗ trợ NFC, bạn có thể bật hoặc tắt NFC theo các bước sau:</p>
              <p className="text-gray-700">- Vào Cài đặt trên điện thoại của bạn.</p>
              <p className="text-gray-700">- Chọn mục "Thiết bị" hoặc "Kết nối" (tùy thuộc vào giao diện của thiết bị).</p>
              <p className="text-gray-700">- Tìm và chọn tùy chọn NFC.</p>
              <p className="text-gray-700">- Kéo thanh trượt để bật hoặc tắt NFC.</p>
              <p className="text-gray-700 mt-2">Ngoài ra, bạn cũng có thể bật hoặc tắt NFC trên điện thoại Android bằng cách kéo thanh thông báo xuống và chạm vào biểu tượng NFC (nếu có) để kích hoạt hoặc tắt tính năng này.</p>
            </div>
          )
        },
        {
          id: 'cau-7',
          title: "Tôi có thể xác thực bằng cách khác nếu không quét được NFC không?",
          content: (
            <div>
              <p className="text-gray-700">Theo Quyết định 2345/QĐ-NHNN về việc triển khai các giải pháp an toàn, bảo mật trong thanh toán trực tuyến và thanh toán thẻ ngân hàng, việc thực hiện các hành vi tạo tài khoản, đăng nhập trên thiết bị khác, hoặc thực hiện các giao dịch chạm hạn mức quy định trong Quyết định này trên nền tảng Ví điện tử (ở đây là GooPay) cần phải xác thực bằng phương pháp xác thực sinh trắc học (ở GooPay là Xác thực khuôn mặt), và thông tin xác thực này cần phải được lưu trong cơ sở dữ liệu sinh trắc học về khách hàng đã thu thập và so khớp với dữ liệu sinh trắc học đọc ra bằng các quét NFC thẻ CCCD gắn chip do Cơ quan Công an cấp.</p>
              <p className="text-gray-700 mt-2">Điều này dẫn đến việc bạn cần phải xác thực NFC thẻ CCCD gắn chip (nếu chưa xác thực trước đó) khi thực hiện tạo tài khoản, đổi thiết bị hoặc giao dịch chạm hạn mức và xác thực khuôn mặt (so khớp thông tin khuôn mặt với khuôn mặt trong thẻ CCCD gắn chip đã thu thập trước đó).</p>
            </div>
          )
        }
      ]
    },
    {
      id: 'privacy-policy',
      title: "Chính sách bảo mật và quyền riêng tư",
      contentItems: [
        {
          id: 'cau-8',
          title: "Liên kết tài khoản ngân hàng của tôi với GooPay có an toàn không?",
          content: (
            <div>
              <p className="text-gray-700">Bạn hoàn toàn an tâm khi liên kết tài khoản ngân hàng của bạn với tài khoản GooPay.</p>
              <p className="text-gray-700 mt-2">Trước hết, để liên kết, bạn phải nhập mã OTP được gửi từ ngân hàng nhằm đảm bảo là chính chủ của tài khoản đang thực hiện liên kết. Trong quá trình sử dụng, mọi giao dịch phát sinh trên GooPay hoặc tài khoản ngân hàng liên kết đều phải được bạn xác nhận. Ngoài ra, GooPay tuyệt đối không lưu thông tin tài khoản ngân hàng/ thẻ của bạn.</p>
            </div>
          )
        },
        {
          id: 'cau-9',
          title: "GooPay có những cơ chế gì để phòng chống lừa đảo và lấy cắp tài khoản?",
          content: (
            <div>
              <p className="text-gray-700">GooPay sử dụng các công nghệ sau để phòng ngừa rủi ro kẻ gian lấy cắp tài khoản của bạn:</p>
              <p className="text-gray-700 mt-2">Khi có người đăng nhập tài khoản GooPay của bạn trên một thiết bị di động khác, GooPay sẽ gửi Voice OTP kèm lời cảnh báo đến số điện thoại đăng ký tài khoản GooPay của bạn với nội dung: "Bạn đang đăng nhập Ví GooPay trên thiết bị khác. Tuyệt đối không chia sẻ mã xác thực OTP này với bất kỳ ai. Mã xác thực là: xxxxxx."</p>
              <p className="text-gray-700 mt-2">Ngoài ra, với một số giao dịch đầu tiên được thực hiện trên thiết bị mới và được GooPay đánh giá là đáng ngờ, GooPay cũng yêu cầu nhập mã xác thực OTP được gửi qua tin nhắn đến số điện thoại đăng ký GooPay.</p>
              <p className="text-gray-700 mt-2">Công nghệ thông minh của GooPay tự động đánh giá và nhận biết các giao dịch bất thường, dựa trên việc phân tích các giao dịch trong quá khứ trên tài khoản GooPay của bạn. Khi phát hiện bất thường, GooPay lập tức chặn giao dịch, ngăn ngừa sự thất thoát tiền trong tài khoản của của bạn.</p>
            </div>
          )
        },
        {
          id: 'cau-10',
          title: "GooPay thu thập các thông tin nào của tôi và dùng để làm gì?",
          content: (
            <div>
              <p className="text-gray-700">👉 Chúng tôi thu thập các thông tin sau:</p>
              <p className="text-gray-700">- Thông tin do bạn cung cấp.</p>
              <p className="text-gray-700">- Thông tin được thu thập tự động.</p>
              <p className="text-gray-700">- Hoạt động của bạn và các thông tin được tạo ra khi bạn tương tác với các Dịch vụ của GooPay.</p>
              <p className="text-gray-700">- Thông tin từ các nguồn khác như từ đối tác thương mại và các bên thứ ba khác.</p>
              <p className="text-gray-700 mt-2">👉 Các thông tin của bạn được chúng tôi sử dụng để vận hành, tăng cường bảo mật cho tài khoản, cung cấp và cải tiến Dịch vụ, tuân thủ các quy định pháp luật (chỉ sau khi được bạn đồng ý). Một số thông tin là không bắt buộc, tuy nhiên nếu không được cung cấp sẽ ảnh hưởng đến chất lượng và trải nghiệm của bạn. Chi tiết bạn có thể xem tại Chính sách quyền riêng tư.</p>
            </div>
          )
        },
        {
          id: 'cau-11',
          title: "Tôi có đọc một số điều khoản nhưng chưa hiểu rõ, tôi phải làm sao?",
          content: (
            <div>
              <p className="text-gray-700">Trong trường hợp có bất kỳ thắc mắc nào về các điều kiện điều khoản này, bạn vui lòng gửi thông tin tại mục 'Trung tâm trợ giúp' trên ứng dụng để GooPay hỗ trợ kiểm tra và xử lý kịp thời.</p>
            </div>
          )
        },
        {
          id: 'cau-12',
          title: "Vì sao GooPay không yêu cầu xác thực bằng mã OTP khi nạp tiền từ ngân hàng liên kết?",
          content: (
            <div>
              <p className="text-gray-700">Việc không yêu cầu xác thực bằng mã OTP khi nạp tiền từ tài khoản ngân hàng liên kết vào GooPay giúp bạn thanh toán tiện lợi, nhanh chóng mà vẫn đảm bảo an toàn. Khi bạn liên kết tài khoản ngân hàng với tài khoản GooPay, bạn đã phải trải qua các bước xác thực danh tính và nhập mã OTP.</p>
              <p className="text-gray-700 mt-2">Một số ngân hàng như BIDV, Vietinbank và VIB vẫn áp dụng xác thực bằng mã OTP khi bạn thực hiện giao dịch vượt quá hạn mức quy định của các ngân hàng này.</p>
              <p className="text-gray-700 mt-2">Ngoài ra, bạn hoàn toàn yên tâm là hệ thống bảo mật của GooPay đảm bảo an toàn cho tài khoản và mọi giao dịch của bạn.</p>
            </div>
          )
        },
        {
          id: 'cau-13',
          title: "GooPay hỗ trợ xử lý lừa đảo và lấy cắp tài khoản như thế nào?",
          content: (
            <div>
              <p className="text-gray-700">Khi GooPay tiếp nhận báo cáo về hành vi lừa đảo, GooPay sẽ hỗ trợ bạn kiểm tra nguồn gốc giao dịch bất thường và khóa tài khoản Ví GooPay của bạn. Đồng thời, GooPay khuyến nghị bạn trình báo vấn đề của mình với công an PC50 - Phòng cảnh sát phòng chống tội phạm công nghệ cao để được hỗ trợ. GooPay sẽ phối hợp với đơn vị điều tra khi nhận được yêu cầu cung cấp các dữ liệu liên quan để phục vụ cho quá trình điều tra.</p>
              <p className="text-gray-700 mt-2">Thông tin liên lạc của Phòng cảnh sát phòng chống tội phạm công nghệ cao.</p>
              <p className="text-gray-700">Địa chỉ:</p>
              <p className="text-gray-700">- Hà Nội: số 47 Phạm Văn Đồng, quận Cầu Giấy</p>
              <p className="text-gray-700">- TP.HCM: số 258 Nguyễn Trãi, quận 1</p>
              <p className="text-gray-700">Số điện thoại: 069.232.1154 hoặc 069.232.1161</p>
              <p className="text-gray-700">Email: C50@canhsat.vn</p>
            </div>
          )
        },
        {
          id: 'cau-14',
          title: "Tôi muốn xóa các thông tin mà GooPay đã thu thập của tôi?",
          content: (
            <div>
              <p className="text-gray-700">GooPay thu thập các dữ liệu và thông tin cần thiết để đảm bảo việc cung cấp và vận hành các sản phẩm, dịch vụ theo quy định pháp luật (chỉ sau khi được bạn đồng ý).</p>
              <p className="text-gray-700 mt-2">👉 Nếu bạn yêu cầu xóa thông tin, GooPay sẽ không thể có đủ thông tin về bạn để duy trì đầy đủ tính năng nhằm đảm bảo trải nghiệm của bạn trên GooPay. Ví dụ, nếu bạn không cung cấp thông tin định danh, GooPay sẽ không thể đánh giá điểm tin cậy để bạn có thể tiếp cận được các sản phẩm đầu tư hay tài chính. Bạn hãy xem xét kỹ trước khi yêu cầu xoá thông tin.</p>
              <p className="text-gray-700 mt-2">👉 Trong trường hợp bạn vẫn muốn xóa các thông tin mà bạn đã cung cấp, bạn thể xem xét yêu cầu xóa tài khoản ví GooPay (xem thông tin chi tiết tại đây). Tuy nhiên, khi đã xoá các thông tin, GooPay rất tiếc không thể tiếp tục cung cấp dịch vụ cho bạn.</p>
            </div>
          )
        }
      ]
    },
    {
      id: 'security-measures',
      title: "Biện pháp tăng cường bảo mật",
      contentItems: [
        {
          id: 'cau-15',
          title: "Cài đặt xác thực mật khẩu khi mở màn hình ứng dụng",
          content: (
            <div>
              <p className="text-gray-700">Để đảm bảo bảo mật tài khoản, ứng dụng GooPay sẽ tự động yêu cầu mật khẩu khi bạn mở ứng dụng sau 5 phút không sử dụng hoặc sau khi đã tắt ứng dụng.</p>
              <p className="text-gray-700 mt-2">Bạn có thể tăng cường độ bảo mật bằng cách cài đặt luôn yêu cầu mật khẩu mỗi khi mở màn hình ứng dụng GooPay, theo các bước sau:</p>
              <p className="text-gray-700">Bước 1: Từ màn hình chính của ứng dụng, chọn "Ví của tôi"</p>
              <p className="text-gray-700">Bước 2: Chọn "Cài đặt" rồi chọn "Thiết lập bảo vệ tài khoản".</p>
              <p className="text-gray-700">Bước 3: Bật tính năng "Xác thực mật khẩu khi mở ứng dụng" (bạn sẽ cần nhập lại mật khẩu để tắt tính năng này)</p>
            </div>
          )
        },
        {
          id: 'cau-16',
          title: "Vì sao cần xác thực tài khoản?",
          content: (
            <div>
              <p className="text-gray-700">Theo Thông tư 23/2019/TT-NHNN ngày 22 tháng 11 năm 2019 sửa đổi, bổ sung một số điều trong Thông tư 39/2014/TT-NHNN ngày 11 tháng 12 năm 2014 của Thống đốc Ngân hàng Nhà nước Việt Nam, tất cả Ví điện tử đang hoạt động phải tiến hành xác thực hồ sơ người dùng trước khi đến thời hạn (dự kiến là ngày 07/07/2020).</p>
              <p className="text-gray-700 mt-2">Sau thời gian dự kiến này, nếu tài khoản Ví GooPay của bạn chưa được xác thực, Ví GooPay của bạn sẽ được tạm khóa dịch vụ cho đến khi việc xác thực hoàn tất.</p>
            </div>
          )
        },
        {
          id: 'cau-17',
          title: "Cách bật tính năng xác thực vân tay",
          content: (
            <div>
              <p className="text-gray-700">Xác thực vân tay dùng cho việc sử dụng dấu vân tay để đăng nhập vào ứng dụng và xác nhận thanh toán một cách nhanh chóng và tiện lợi. Lưu ý: tất cả vân tay đã được đăng ký trong thiết bị của bạn đều đã được xác thực.</p>
              <p className="text-gray-700 mt-2">Để bật tính năng xác thực vân tay, bạn hãy thực hiện các bước sau:</p>
              <p className="text-gray-700">Bước 1: Từ màn hình chính của ứng dụng, chọn "Ví của tôi".</p>
              <p className="text-gray-700">Bước 2: Chọn "Cài đặt" rồi chọn "Thiết lập bảo vệ tài khoản". Truy cập nhanh tại đây.</p>
              <p className="text-gray-700">Bước 3: Bật chức năng xác thực vân tay (bạn sẽ cần nhập lại mật khẩu để bật chức năng này)</p>
            </div>
          )
        },
        {
          id: 'cau-18',
          title: "Khi nào nên đổi mật khẩu?",
          content: (
            <div>
              <p className="text-gray-700">GooPay có quy định đổi mật khẩu định kỳ 6 tháng 1 lần và mật khẩu mới không được trùng với mật khẩu đang dùng.</p>
              <p className="text-gray-700 mt-2">Tuy nhiên GooPay khuyến nghị bạn đổi mật khẩu thường xuyên hoặc khi bạn nghi ngờ có kẻ gian đang tìm cách truy cập vào tài khoản GooPay của bạn. Bạn lưu ý đặt mật khẩu có độ bảo mật cao (không liên quan đến các thông tin cá nhân như ngày sinh, số điện thoại, không đặt 6 số trùng nhau, 6 số liên tiếp...).</p>
            </div>
          )
        },
        {
          id: 'cau-19',
          title: "Nhận biết dấu hiệu lừa đảo như thế nào?",
          content: (
            <div>
              <p className="text-gray-700">Những kẻ lừa đảo thường giả mạo GooPay liên lạc với bạn để yêu cầu tiết lộ các thông tin bảo mật như mật khẩu, thông tin tài khoản ngân hàng, mã OTP, v.v…</p>
              <p className="text-gray-700 mt-2">Để cảnh giác với kẻ gian, xin bạn lưu ý những điều sau:</p>
              <p className="text-gray-700">1. GooPay KHÔNG BAO GIỜ yêu cầu bạn cung cấp mã OTP, mật khẩu tài khoản GooPay hay số tài khoản ngân hàng. Hãy báo ngay với GooPay khi có người yêu cầu bạn cung cấp những thông tin này.</p>
              <p className="text-gray-700 mt-2">2. GooPay chỉ liên hệ trực tiếp với bạn thông qua các hình thức sau:</p>
              <p className="text-gray-700">- Điện thoại: 19006038</p>
              <p className="text-gray-700">- Email: cskh@goopay.vn</p>
              <p className="text-gray-700">- Facebook của Ví GooPay: https://www.facebook.com/goopay/</p>
              <p className="text-gray-700 mt-2">3. Bạn có thể cập nhật hoặc kiểm tra thông tin chính thức từ GooPay qua các kênh sau:</p>
              <p className="text-gray-700">- Website GooPay: Goopay.vn</p>
              <p className="text-gray-700">- Fanpage Facebook của Ví GooPay: https://www.facebook.com/goopay/</p>
              <p className="text-gray-700">- Liên hệ với bộ phận CSKH của GooPay. Xem cách thức liên hệ tại đây.</p>
            </div>
          )
        },
        {
          id: 'cau-20',
          title: "Tôi muốn báo cáo hành vi giả mạo GooPay",
          content: (
            <div>
              <p className="text-gray-700">Vui lòng để lại lời nhắn bên dưới cho bộ phận CSKH và cung cấp các thông tin sau:</p>
              <p className="text-gray-700">- Nội dung: phát hiện hành vi giả mạo</p>
              <p className="text-gray-700">- Mô tả chi tiết hành vi</p>
              <p className="text-gray-700 mt-2">Hoặc bạn có thể liên hệ với bộ phận CSKH của GooPay qua các cách khác.</p>
            </div>
          )
        },
        {
          id: 'cau-21',
          title: "Vì sao cần xác thực email?",
          content: (
            <div>
              <p className="text-gray-700">Sau bước tạo tài khoản với GooPay, GooPay sẽ gửi email đến địa chỉ email đã nhập của bạn để xác nhận đây đúng là địa chỉ email của bạn. Sau khi đã xác thực email, bạn sẽ nhận được các thông tin liên quan tới bảo mật tài khoản trong các trường hợp như:</p>
              <p className="text-gray-700">- Cảnh báo tài khoản được đăng nhập trên thiết bị khác</p>
              <p className="text-gray-700">- Lấy lại mật khẩu khi bạn có yêu cầu</p>
              <p className="text-gray-700">- Thông tin kết quả giao dịch</p>
            </div>
          )
        }
      ]
    },
    {
      id: 'emergency-incidents',
      title: "Sự cố khẩn cấp",
      contentItems: [
        {
          id: 'cau-22',
          title: "Hướng dẫn kiểm tra khi phát hiện giao dịch bất thường",
          content: (
            <div>
              <p className="text-gray-700">Trước hết, bạn vui lòng kiểm tra trong mục "Lịch Sử Giao Dịch" xem tài khoản GooPay của bạn có phát sinh giao dịch nào mà bạn không thực hiện hoặc bạn đã cung cấp thông tin mật khẩu/ mã OTP cho người khác hoặc nghi ngờ có người khác biết được thông tin Ví GooPay của bạn, hãy ngay lập tức đổi mật khẩu Ví GooPay và liên hệ tổng đài GooPay tại số 19006038 để tạm khóa gấp tài khoản. Các bước tạm khóa ví tự động xem tại đây</p>
            </div>
          )
        },
        {
          id: 'cau-23',
          title: "Tài khoản của tôi bị khóa",
          content: (
            <div>
              <p className="text-gray-700">Khi đăng nhập vào ứng dụng và bạn nhận được thông báo tài khoản bị khóa, có thể do 1 trong các nguyên nhân sau:</p>
              <p className="text-gray-700">- Bạn đã nhập sai mật khẩu đăng nhập nhiều lần nên tài khoản GooPay của bạn tạm thời bị khóa.</p>
              <p className="text-gray-700">- Bạn đã vi phạm điều khoản sử dụng ứng dụng GooPay.</p>
              <p className="text-gray-700">- Hệ thống GooPay ghi nhận hành vi bất thường nên tạm thời khóa tài khoản GooPay của bạn.</p>
              <p className="text-gray-700 mt-2">Trong trường hợp này, bạn vui lòng dùng chính số điện thoại đăng ký tài khoản GooPay để liên hệ đến tổng đài GooPay 19006038. Nhân viên CSKH sẽ xác minh thông tin và hỗ trợ.</p>
            </div>
          )
        },
        {
          id: 'cau-24',
          title: "Các bước tạm khóa tài khoản tự động qua tổng đài",
          content: (
            <div>
              <p className="text-gray-700">Trong trường hợp tài khoản GooPay của bạn phát sinh giao dịch mà bạn không thực hiện hoặc bạn đã cung cấp thông tin mật khẩu/ mã OTP cho người khác hoặc nghi ngờ có người khác biết được thông tin Ví GooPay của bạn, bạn cần thực hiện khóa ví ngay bằng cách:</p>
              <p className="text-gray-700">Bước 1: Liên hệ ngay lập tức đến số tổng đài 19006038</p>
              <p className="text-gray-700">Bước 2: Để báo khóa tài khoản khẩn cấp, vui lòng bấm phím 1.</p>
              <p className="text-gray-700">Bước 3:</p>
              <p className="text-gray-700">- Để khóa tài khoản số điện thoại đang gọi: bấm phím 1</p>
              <p className="text-gray-700">- Để khóa tài khoản của số điện thoại khác: bấm phím 2.</p>
              <p className="text-gray-700">Bước 4:</p>
              <p className="text-gray-700">- Trường hợp khóa tài khoản số điện thoại đang gọi: Hệ thống sẽ đọc lại số điện thoại cần khóa. Bạn vui lòng bấm phím 1 sau tiếng bíp để xác nhận lệnh khóa.</p>
              <p className="text-gray-700">- Trường hợp khóa tài khoản của số điện thoại khác: Hệ thống sẽ chuyển đến Điện thoại viên để thực hiện khóa Ví.</p>
              <p className="text-gray-700 mt-2">♦ Khóa số GooPay</p>
              <p className="text-gray-700">♦ Mở khóa số GooPay</p>
            </div>
          )
        },
        {
          id: 'cau-25',
          title: "Tôi bị mất điện thoại",
          content: (
            <div>
              <p className="text-gray-700">Bạn có thể gặp 1 trong 2 trường hợp:</p>
              <p className="text-gray-700 mt-2"><strong>Trường hợp 1: Mất cả điện thoại kèm sim đăng ký tài khoản ví GooPay</strong></p>
              <p className="text-gray-700">Kẻ gian có thể không truy cập vào tài khoản GooPay trên điện thoại của bạn nếu không có mật khẩu đăng nhập/các thông tin xác minh liên quan. Tuy nhiên để đảm bảo an toàn tuyệt đối, bạn cần gọi ngay Tổng đài nhà mạng để thực hiện khóa 2 chiều nghe và gọi của sim, đồng thời liên hệ Tổng đài GooPay 19006038 để được hỗ trợ khóa tài khoản GooPay.</p>
              <p className="text-gray-700 mt-2"><strong>Trường hợp 2: Mất điện thoại nhưng vẫn giữ sim đăng ký tài khoản GooPay</strong></p>
              <p className="text-gray-700">Hãy lắp sim vào 1 thiết bị điện thoại khác và đăng nhập ngay vào tài khoản GooPay của mình. Bạn sẽ được tổng đài tự động của GooPay liên hệ để cung cấp mã OTP. Đồng thời, tài khoản GooPay của bạn trên thiết bị cũ sẽ tự động đăng xuất. Kẻ gian sẽ không thể đăng nhập được vào tài khoản Ví GooPay của bạn trên thiết bị cũ khi không có mã OTP cũng như mật khẩu của bạn</p>
            </div>
          )
        }
      ]
    },
    {
      id: 'account-verification',
      title: "Xác thực tài khoản",
      contentItems: [
        {
          id: 'cau-26',
          title: "Tại sao tôi cần xác thực tài khoản Ví GooPay?",
          content: (
            <div>
              <p className="text-gray-700">Theo quy định của Ngân hàng nhà nước tại Thông tư 23/2019/TT-NHNN, người dùng sử dụng Ví điện tử bắt buộc phải xác thực tài khoản Ví và liên kết với Tài khoản ngân hàng.</p>
              <p className="text-gray-700 mt-2">Ví GooPay của bạn cần thực hiện đúng theo quy định trên để tiếp tục sử dụng dịch vụ.</p>
              <p className="text-gray-700 mt-2">Ngoài ra, GooPay khuyến khích người dùng xác thực khuôn mặt. Điều này sẽ giúp:</p>
              <p className="text-gray-700">☑️ Khẳng định người dùng là chủ sở hữu của tài khoản Ví GooPay.</p>
              <p className="text-gray-700">☑️ Tăng cường bảo mật thông tin cá nhân và thông tin giao dịch trong Ví.</p>
              <p className="text-gray-700">☑️ Giảm thiểu gian lận, trộm cắp danh tính, hoạt động rửa tiền và các hoạt động phạm pháp khác.</p>
              <p className="text-gray-700">☑️ Nhận thêm nhiều ưu đãi từ GooPay.</p>
            </div>
          )
        },
        {
          id: 'cau-27',
          title: "Ai là người phải xác thực tài khoản Ví GooPay?",
          content: (
            <div>
              <p className="text-gray-700">Theo quy định của Ngân hàng nhà nước tại Thông tư 23/2019/TT-NHNN, cá nhân sử dụng Ví điện tử bắt buộc phải xác thực tài khoản Ví và liên kết với Tài khoản ngân hàng.</p>
              <p className="text-gray-700 mt-2">Ví GooPay của Khách hàng cần thực hiện đúng theo quy định trên để tiếp tục sử dụng dịch vụ.</p>
              <p className="text-gray-700 mt-2">Nếu tài khoản Ví GooPay của bạn chưa được xác thực, Ví GooPay của bạn sẽ bị tạm khóa dịch vụ cho đến khi việc xác thực hoàn tất.</p>
            </div>
          )
        },
        {
          id: 'cau-28',
          title: "Xác thực tài khoản ví có lợi ích gì?",
          content: (
            <div>
              <p className="text-gray-700">Xác thực thông tin người dùng (KYC - Know Your Customer) Ví điện tử là quy định của Ngân hàng Nhà nước với mục đích tăng cường bảo mật tài chính và xây dựng một nền tảng thanh toán giảm thiểu gian lận, trộm cắp danh tính, hoạt động "rửa tiền" và các hành động phạm pháp khác. Xem chi tiết nội dung Thông tư 23 http://bit.ly/TT23-NHNN</p>
            </div>
          )
        },
        {
          id: 'cau-29',
          title: "Tôi muốn thay đổi thông tin xác thực tài khoản",
          content: (
            <div>
              <p className="text-gray-700">Để được hỗ trợ thay đổi thông tin tài khoản Ví đã được xác thực, như:</p>
              <p className="text-gray-700">- Thay đổi loại giấy tờ tùy thân (CMND/CCCD/Hộ chiếu)</p>
              <p className="text-gray-700">- Thay đổi thông tin giấy tờ tùy thân đã được xác thực</p>
              <p className="text-gray-700 mt-2">Bạn vui lòng gửi yêu cầu ở mục Trợ giúp trên ví GooPay kèm hình ảnh CMND/CCCD/Hộ chiếu (theo thông tin mong muốn được cập nhật) để GooPay có thể hỗ trợ bạn.</p>
              <p className="text-gray-700 mt-2">Lưu ý:</p>
              <p className="text-gray-700">- Nếu hệ thống đang chờ xác thực bạn vui lòng chờ đến khi hệ thống báo đã xác thực xong.</p>
              <p className="text-gray-700">- Nếu hệ thống từ chối xác thực bạn hãy làm lại bước xác thực với thông tin chính xác.</p>
            </div>
          )
        },
        {
          id: 'cau-30',
          title: "Tại sao không thể thực hiện giao dịch khi đã liên kết ngân hàng thành công?",
          content: (
            <div>
              <p className="text-gray-700">Để sử dụng được dịch vụ, bên cạnh việc liên kết ngân hàng, bạn cần phải thực hiện xác thực tài khoản theo quy định của Ngân hàng Nhà nước. Để thao tác xác thực tài khoản, bạn hãy thực hiện theo các bước hướng dẫn sau:</p>
              <p className="text-gray-700 mt-2">Đăng nhập vào ứng dụng</p>
              <p className="text-gray-700"><strong>B1:</strong> Từ màn hình chính của ứng dụng, bạn có thể chọn 1 trong 3 cách sau để cập nhật thông tin chủ Ví như sau:</p>
              <p className="text-gray-700">Cách 1: Tại màn hình chính, chọn biểu tượng hình đại diện ở góc trên bên phải để vào "Trang cá nhân của tôi" → chọn "Chụp CMND ngay!"</p>
              <p className="text-gray-700">Cách 2: Tại màn hình chính, chọn "Ví của tôi" → chọn "Chụp CMND ngay!"</p>
              <p className="text-gray-700">Cách 3: Tại màn hình chính, chọn "Ví của tôi" → chọn mục "Trung tâm bảo mật" → chọn "Xác thực ngay" trong phần "Thông tin xác thực tài khoản"</p>
              <p className="text-gray-700 mt-2"><strong>B2:</strong> Chụp ảnh CMND/CCCD mặt trước- mặt sau hoặc Hộ chiếu - trang 2 và 3</p>
              <p className="text-gray-700 mt-2"><strong>B3:</strong> Kiểm tra thông tin.</p>
              <p className="text-gray-700">Các thông tin từ CMND/ CCCD/ Hộ chiếu sẽ được tự động điền vào các ô thông tin, bạn vui lòng kiểm tra chính xác thông tin và nhấn "Xác nhận" để tiếp tục.</p>
              <p className="text-gray-700 mt-2">Lưu ý: Theo Thông tư 23/2019/TT-NHNN, thông tin chủ Ví GooPay bắt buộc trùng khớp thông tin liên kết ngân hàng. Do đó, nếu bạn chưa cung cấp thông tin ngân hàng, hãy liên kết ngân hàng ngay để có thể tiếp tục sử dụng các dịch vụ của Ví GooPay nhé! Tham khảo thêm tại đây: /hoi-dap/nap-rut-tien-ctgr3/lien-ket-tai-khoan-ngan-hang</p>
              <p className="text-gray-700 mt-2"><strong>B4:</strong> Xác thực khuôn mặt</p>
              <p className="text-gray-700">- Giữ điện thoại cố định</p>
              <p className="text-gray-700">- Đưa khuôn mặt của bạn vào khung hình tròn</p>
              <p className="text-gray-700">- Di chuyển khuôn mặt từ từ theo hướng dẫn</p>
              <p className="text-gray-700">- Sau khi hoàn thành bạn hãy trở lại màn hình chính để chờ kết quả nhé</p>
            </div>
          )
        },
        {
          id: 'cau-31',
          title: "Hộ chiếu nước ngoài có được xác thực không?",
          content: (
            <div>
              <p className="text-gray-700">GooPay hiện vẫn sử dụng hộ chiếu nước ngoài để xác thực tài khoản cho Ví trên ứng dụng. Trong trường hợp nhận được thông báo không thành công khi chụp hộ chiếu, bạn vui lòng thực hiện lại thêm hai hoặc ba lần nữa để xác thực lại.</p>
              <p className="text-gray-700 mt-2">Xin lưu ý: Hình chụp cần được căn chỉnh rõ ràng, đầy đủ thông tin, không mất góc hoặc tránh không bị chói sáng mất nét.</p>
              <p className="text-gray-700 mt-2">Trong trường vẫn không thể xác thực được, bạn vui lòng gửi yêu cầu hỗ trợ hoặc liên hệ tổng đài 19006038 để GooPay có thể hỗ trợ bạn kịp thời.</p>
            </div>
          )
        },
        {
          id: 'cau-32',
          title: "Tôi đã và đang sử dụng ví GooPay trước khi thông tư được ban hành, vậy tôi có cần phải xác thực tài khoản?",
          content: (
            <div>
              <p className="text-gray-700">Theo quy định của Ngân hàng nhà nước tại Thông tư 23/2019/TT-NHNN, tất cả người dùng sử dụng Ví điện tử bắt buộc phải xác thực tài khoản Ví và liên kết với Tài khoản ngân hàng.</p>
              <p className="text-gray-700 mt-2">Để được tiếp tục sử dụng dịch vụ, rất mong bạn hoàn tất các thao tác xác thực như quy định.</p>
            </div>
          )
        },
        {
          id: 'cau-33',
          title: "Thông tin tôi cung cấp khi xác thực được bảo vệ như thế nào?",
          content: (
            <div>
              <p className="text-gray-700">GooPay cam kết bảo mật tuyệt đối thông tin và hình ảnh mà bạn đã cung cấp. Thông tin chỉ được sử dụng để xác thực tài khoản theo quy định của Ngân hàng Nhà nước.</p>
              <p className="text-gray-700 mt-2">Bạn có thể tham khảo thêm Chính sách quyền riêng tư của Ví GooPay tại đây: /chinh-sach-quyen-rieng-tu</p>
              <p className="text-gray-700 mt-2">(*) Chính sách quyền riêng tư của Ví GooPay tuân thủ đúng quy định của pháp luật về bảo vệ dữ liệu. Chính sách quyền riêng tư của Ví GooPay đảm bảo sử dụng thông tin thu thập được để cung cấp dịch vụ, tính năng, chương trình khuyến mại; tăng cường bảo mật; hỗ trợ khi chủ Ví yêu cầu và phục vụ các mục đích liên quan đến thủ tục pháp lý.</p>
            </div>
          )
        },
        {
          id: 'cau-34',
          title: "Nếu tôi không muốn xác thực tài khoản Ví GooPay của mình, tiền trong Ví của tôi có mất không?",
          content: (
            <div>
              <p className="text-gray-700">Tiền của bạn vẫn được đảm bảo duy trì trong trong tài khoản Ví GooPay.</p>
              <p className="text-gray-700 mt-2">Tuy nhiên, bạn cần phải thực hiện xác thực tài khoản để tiếp tục sử dụng phần tiền này. Trường hợp bạn cần tư vấn thêm thông tin chi tiết hoặc hỗ trợ thêm xin vui lòng gửi ngay yêu cầu đến GooPay nhé.</p>
            </div>
          )
        },
        {
          id: 'cau-35',
          title: "Nếu tôi đã xác thực tài khoản nhưng chưa liên kết Ngân Hàng thì có thể thực hiện giao dịch không?",
          content: (
            <div>
              <p className="text-gray-700">Nếu Ví GooPay của bạn chỉ mới xác thực tài khoản nhưng chưa thực hiện việc liên kết tài khoản ngân hàng, thì rất tiếc bạn vẫn chưa đủ điều kiện sử dụng dịch vụ. Nhằm giúp tài khoản Ví có thể sử dụng được toàn bộ các tính năng trên ứng dụng, bạn cần thực hiện theo hướng dẫn liên kết Ví GooPay với tài khoản ngân hàng.</p>
              <p className="text-gray-700 mt-2">Tham khảo tại đây /huong-dan/lien-ket-ngan-hang-ctgr67</p>
              <p className="text-gray-700 mt-2">Lưu ý: Thông tin chủ Ví và thông tin liên kết tài khoản ngân hàng/chủ thẻ bắt buộc phải trùng khớp. Trường hợp bạn cần tư vấn thêm thông tin chi tiết hoặc đã thực hiện liên kết nhưng vẫn chưa sử dụng được dịch vụ, hãy gửi ngay yêu cầu đến GooPay nhé.</p>
            </div>
          )
        },
        {
          id: 'cau-36',
          title: "Thời gian để GooPay xác thực tài khoản là bao lâu?",
          content: (
            <div>
              <p className="text-gray-700">Kể từ lúc bạn hoàn thành việc xác nhận các thông tin tại bước Xác thực tài khoản, Ví GooPay của bạn sẽ được xác thực sau chậm nhất 24h (Không tính Thứ 7, Chủ nhật và ngày Lễ).</p>
              <p className="text-gray-700 mt-2">Nếu quá thời gian trên mà Ví của bạn chưa được xác thực, vui lòng gửi yêu cầu hỗ trợ để báo cho GooPay biết về tình huống này. GooPay rất tiếc về những bất tiện mà bạn gặp phải.</p>
            </div>
          )
        },
        {
          id: 'cau-37',
          title: "Những loại giấy tờ cần dùng để xác thực tài khoản là gì?",
          content: (
            <div>
              <p className="text-gray-700">Người dùng GooPay có thể tùy chọn một trong các loại giấy tờ sau để xác thực tài khoản Ví điện tử:</p>
              <p className="text-gray-700">- Chứng minh nhân dân</p>
              <p className="text-gray-700">- Căn cước công dân</p>
              <p className="text-gray-700">- Hộ chiếu</p>
              <p className="text-gray-700 mt-2">Lưu ý:</p>
              <p className="text-gray-700">- Thông tin trên giấy tờ còn hiệu lực sử dụng và trùng khớp với thông tin bạn đã đăng ký với GooPay và ngân hàng.</p>
              <p className="text-gray-700">- Mỗi 1 CMND/CCCD/Hộ chiếu chỉ được xác thực tối đa 3 Ví.</p>
              <p className="text-gray-700">- Nếu bạn đã gửi thông tin hình ảnh CMND/CCCD/Hộ chiếu mà hệ thống báo lỗi, bạn vui lòng thực hiện lại.</p>
              <p className="text-gray-700">- Nếu thông tin xác thực bị từ chối bạn có thể thực hiện lại việc xác thực cho đến khi nhận được thông báo xác thực thành công hoặc gửi yêu cầu trợ giúp để GooPay kịp thời hỗ trợ bạn nhé.</p>
            </div>
          )
        },
        {
          id: 'cau-38',
          title: "Điều gì sẽ xảy ra nếu tôi không xác thực tài khoản Ví GooPay của mình?",
          content: (
            <div>
              <p className="text-gray-700">Theo quy định của Ngân hàng nhà nước tại Thông tư 23/2019/TT-NHNN, cá nhân sử dụng Ví điện tử bắt buộc phải xác thực tài khoản Ví và liên kết với Tài khoản ngân hàng. Ví GooPay của Khách hàng cần thực hiện đúng theo quy định trên để tiếp tục sử dụng dịch vụ.</p>
              <p className="text-gray-700 mt-2">Nếu tài khoản Ví GooPay của bạn chưa được xác thực, Ví GooPay của bạn sẽ bị tạm khóa dịch vụ cho đến khi việc xác thực hoàn tất.</p>
            </div>
          )
        },
        {
          id: 'cau-39',
          title: "Một CMND/CCCD có thể xác thực được bao nhiêu ví?",
          content: (
            <div>
              <p className="text-gray-700">Bạn có thể sử dụng mỗi CMND/CCCD/Hộ chiếu để xác thực tối đa 3 Ví GooPay.</p>
              <p className="text-gray-700 mt-2">Trong trường hợp CMND/CCCD này đã xác thực tối đa 3 ví và bạn muốn dùng CMND/ CCCD này để xác thực một ví khác, bạn vui lòng gửi yêu cầu hủy xác thực bằng số ví bạn muốn hủy để GooPay có thể hỗ trợ bạn kịp thời</p>
            </div>
          )
        },
        {
          id: 'cau-40',
          title: "Tôi chụp CMND/CCCD để xác thực tài khoản nhưng bị lỗi hình ảnh",
          content: (
            <div>
              <p className="text-gray-700">Trường hợp này có thể do các lỗi sau:</p>
              <p className="text-gray-700">- Hình chụp bị mờ, chói sáng hoặc quá tối: Bạn vui lòng thực hiện xác thực lại. Bạn cần canh chỉnh hình chụp CMND/ CCCD rõ ràng và đầy đủ thông tin</p>
              <p className="text-gray-700">- CMND/ CCCD/ Hộ chiếu bạn dùng không phải giấy tờ gốc: Bạn vui lòng thực hiện xác thực lại và không dùng CMND/ CCCD/ Hộ chiếu bản photocopy/ photoshop/bản chụp qua các màn hình thiết bị điện tử khác.</p>
              <p className="text-gray-700">- CMND/ CCCD/ Hộ chiếu bị bôi bẩn, nhàu nát, gấp gãy.</p>
              <p className="text-gray-700">- CMND/ CCCD/ Hộ chiếu của bạn đã được xác thực đủ 3 ví: Bạn vui lòng gọi tới GooPay qua hotline 19006038 hoặc gửi yêu cầu ở mục Trợ giúp trên ví GooPay để được hỗ trợ hủy xác thực ví cũ và tiến hành xác thực lại trên ví mới.</p>
              <p className="text-gray-700 mt-2">Trong trường hợp đã thử xác thực lại vẫn không được bạn hãy thử lại 1 lần nữa. GooPay chân thành xin lỗi mong bạn thông cảm vì sự bất tiện này.</p>
            </div>
          )
        },
        {
          id: 'cau-41',
          title: "Tôi chụp CMND để xác thực tài khoản nhưng dịch vụ đang bảo trì",
          content: (
            <div>
              <p className="text-gray-700">Trường hợp này có thể do một vài vấn đề xảy ra trong quá trình xử lý hình ảnh. Bạn vui lòng thoát ra khỏi tính năng và vào thực hiện lại bước Xác thực tài khoản sau 5 phút nữa.</p>
              <p className="text-gray-700 mt-2">GooPay chân thành xin lỗi mong bạn thông cảm vì sự bất tiện này.</p>
            </div>
          )
        },
        {
          id: 'cau-42',
          title: "Tôi cần thực hiện những bước nào để xác thực tài khoản Ví GooPay?",
          content: (
            <div>
              <p className="text-gray-700">Để thao tác xác thực tài khoản, bạn hãy thực hiện theo các bước hướng dẫn sau:</p>
              <p className="text-gray-700 mt-2">Đăng nhập vào ứng dụng</p>
              <p className="text-gray-700"><strong>B1:</strong> Từ màn hình chính của ứng dụng, chọn biểu tượng hình đại diện "Tôi" ở góc bên phải</p>
              <p className="text-gray-700"><strong>B2:</strong> Chọn Chụp CMND/CCCD ở phần trên màn hình</p>
              <p className="text-gray-700"><strong>B3:</strong> Xác thực chứng từ</p>
              <p className="text-gray-700">3.1 Chọn Bắt đầu chụp để chụp ảnh CMND/CCCD mặt trước và mặt sau hoặc Hộ chiếu</p>
              <p className="text-gray-700">3.2 Kiểm tra thông tin</p>
              <p className="text-gray-700">Các thông tin từ CMND/ CCCD/ Hộ chiếu sẽ được tự động điền vào các ô thông tin, bạn vui lòng kiểm tra chính xác thông tin và nhấn "Xác nhận" để tiếp tục.</p>
              <p className="text-gray-700 mt-2">Lưu ý: Theo Thông tư 23/2019/TT-NHNN, thông tin chủ Ví GooPay bắt buộc trùng khớp thông tin liên kết ngân hàng. Do đó, nếu bạn chưa cung cấp thông tin ngân hàng, hãy liên kết ngân hàng ngay để có thể tiếp tục sử dụng các dịch vụ của Ví GooPay nhé! Tham khảo thêm tại đây: /hoi-dap/nap-rut-tien-ctgr3/lien-ket-tai-khoan-ngan-hang</p>
              <p className="text-gray-700 mt-2"><strong>B4:</strong> Xác thực khuôn mặt</p>
              <p className="text-gray-700">- Giữ điện thoại cố định</p>
              <p className="text-gray-700">- Đưa khuôn mặt của bạn vào khung hình tròn</p>
              <p className="text-gray-700">- Di chuyển khuôn mặt từ từ theo hướng dẫn</p>
              <p className="text-gray-700">- Sau khi hoàn thành bạn hãy trở lại màn hình chính để chờ kết quả nhé</p>
            </div>
          )
        },
        {
          id: 'cau-43',
          title: "Xác thực tài khoản ví điện tử là gì?",
          content: (
            <div>
              <p className="text-gray-700">Xác thực thông tin người dùng (KYC - Know Your Customer) Ví điện tử là quy định của Ngân hàng Nhà nước với mục đích tăng cường bảo mật tài chính và xây dựng một nền tảng thanh toán giảm thiểu gian lận, trộm cắp danh tính, hoạt động "rửa tiền" và các hành động phạm pháp khác. Xem chi tiết nội dung Thông tư 23 http://bit.ly/TT23-NHNN</p>
            </div>
          )
        },
        {
          id: 'cau-44',
          title: "Tại sao tôi đã liên kết Ví GooPay với tài khoản ngân hàng (đã được xác thực bằng CMND) mà vẫn phải cung cấp CMND để xác thực tài khoản trên Ví GooPay?",
          content: (
            <div>
              <p className="text-gray-700">Theo Thông tư 23/2019/TT-NHNN, thông tin xác thực ví cần đảm bảo:</p>
              <p className="text-gray-700">- Chủ Ví GooPay đã cung cấp đầy đủ hình chụp CMND/ CCCD/ Hộ chiếu.</p>
              <p className="text-gray-700">- Thông tin chủ Ví GooPay bắt buộc trùng khớp thông tin liên kết ngân hàng.</p>
              <p className="text-gray-700 mt-2">Bạn có thể tham khảo cách xác thực tài khoản tại đây:</p>
              <p className="text-gray-700 mt-2">Trong trường hợp một trong các thông tin trên chưa chính xác, bạn có thể nhận được yêu cầu xác thực lại. Xin vui lòng thực hiện lại xác thực, để đảm bảo đúng và đủ các điều kiện trên. GooPay xin lỗi vì sự bất tiện này.</p>
            </div>
          )
        }
      ]
    }
  ]
}; 